module.exports = __webpack_public_path__ + "9445f65501c4e7b67216cf3bac37df7c.png";